export const inputAcceptImages = "image/jpg, image/jpeg, image/png, image/webp";
